<template>
    <div class="grid grid-cols-1">
        <div>
            <InputRadio v-model="model.redPlate" lazy @willChange="onRedPlateChange($event)">
                ป้ายแดง <span class="text-a-gray-a8a8a8">(Optional)</span>
            </InputRadio>
        </div>

        <InputText v-show="formType != 'now'" :inputLbl="lbl.appointment.claimFormNonRegister.appointLocation" :errorInfo="errInfo[0]"
            v-model:inputValue="model.appointmentLocation" :isSubmitted="isSubmitted" :isShowError="true"
            :maxLength="500" :isDisable="isDisable" showErrorOnBlur errorAppend />

        <DateTimePicker
            :inputLbl="{ date: lbl.appointment.claimFormNonRegister.claimDate, time: lbl.appointment.claimFormNonRegister.claimTime }"
            :errorInfo="errInfo[1]" v-model:inputValue="model.claimDate" v-model:time="model.claimTime"
            :isSubmitted="isSubmitted" :isShowError="true" :isDisabled="true" fixedDate />

        <template v-if="formType == 'appointment'">
            <DateTimePicker
                :inputLbl="{ date: lbl.appointment.claimFormNonRegister.appointDate, time: lbl.appointment.claimFormNonRegister.appointTime }"
                :errorInfo="errInfo[8]" :lowerLimit="minDate" v-model:inputValue="model.appointDate"
                v-model:time="model.appointTime" :isSubmitted="isSubmitted" :isShowError="true" :isDisabled="isDisable" />
        </template>

        <InputDropdown v-show="formType != 'now'" :inputLbl="lbl.appointment.claimFormNonRegister.nameTitle" :errorInfo="errInfo[2]"
            :itemList="ddlTitleName" v-model:inputValue="model.nameTitle" :isSubmitted="isSubmitted" :isShowError="true" :isDisable="isDisable" />

        <InputText :inputLbl="lbl.appointment.claimFormNonRegister.driverName" :errorInfo="errInfo[3]"
            v-model:inputValue="model.driverName" :isSubmitted="isSubmitted" :isShowError="true" isTextOnly
            :maxLength="100" :isDisable="isDisable" showErrorOnBlur errorAppend />

        <InputContactNumber :inputLbl="lbl.appointment.claimFormNonRegister.contactNumber" :errorInfo="errInfo[4]"
            v-model:inputValue="model.contactNumber" :isSubmitted="isSubmitted" :isShowError="true" :minLength="10" :maxLength="10" :isDisable="isDisable" showErrorOnBlur errorAppend />

        <InputNationalId :inputLbl="lbl.appointment.claimFormNonRegister.citizenId" :errorInfo="errInfo[5]"
            v-model:inputValue="model.citizenId" :isSubmitted="isSubmitted" :isShowError="true" :isDisable="isDisable" showErrorOnBlur errorAppend />

        <InputTermsAndCond v-model="model.acceptTermsAndCond" />

        <InputText :inputLbl="lbl.appointment.claimFormNonRegister.carNo" :errorInfo="errInfo[6]"
            v-model:inputValue="model.carNo" :isSubmitted="isSubmitted" :isShowError="true" :maxLength="50" :isDisable="isDisable" showErrorOnBlur errorAppend />

        <InputDropdown :inputLbl="lbl.appointment.claimFormNonRegister.province" :errorInfo="errInfo[7]"
            :itemList="ddlProvince" v-model:inputValue="model.province" :isSubmitted="isSubmitted" :isShowError="true" :isDisable="isDisable" @update:inputValue="onUpdateProvince($event)" />
        <div class="pb-1"></div>
        <template v-if="formConfig.upload_id_card == true">
            <InputUpload v-model="model.imgIdCard" title="ภาพถ่ายใบอนุญาติขับขี่ / บัตรประชาชน" required requireMsg="กรุณาเลือกรูปภาพใบขับขี่ / บัตรประชาชน" :isSubmitted="isSubmitted" :isDisable="isDisable" />
        </template>

        <template v-if="formConfig.upload_car_plate == true">
            <InputUpload v-model="model.imgCarPlate" title="ภาพถ่ายทะเบียนรถ" required requireMsg="กรุณาเลือกรูปภาพทะเบียนรถ" :isSubmitted="isSubmitted" :isDisable="isDisable" />
        </template>

        <div class="mt-0">
            <MainButton size="md-half2" block :disabled="!isCanSubmit || isDisable" disabledColor="a-gray-e5e5e5" disabledTextColor="text-a-gray-a8a8a8" @click="submitForm()" class="">
                ยืนยันแจ้งเคลมแบบไม่ลงทะเบียน
            </MainButton>
        </div>
    </div>
</template>
<script>
import { computed, inject, ref } from 'vue'
import { FormHelper } from '@/helper/FormHelper'
import { DateTime } from 'luxon'
import { ClaimNoRegisterModel } from "../model/ClaimNoRegisterModel"
import ClaimNonRegisterService from '../service/ClaimNonRegisterService'
// component
import InputText from '@/components/Input/label2/InputText.vue'
import InputDropdown from '@/components/Input/label2/InputDropdown.vue'
import InputContactNumber from '@/components/Input/label2/InputContactNumber.vue'
import InputNationalId from '@/components/Input/label2/InputNationalId.vue'
import DateTimePicker from "../component/DateTimePickerStyle2.vue"
import MainButton from '@/components/Button/MainButton.vue'
import InputTermsAndCond from './InputTermsAndCond.vue'
import InputRadio from '@/components/Input/label2/InputRadio.vue'
import InputUpload from './InputUpload.vue'

export default {
    props: {
        formType: {
            type: String,
            default: "now"
        },
        formConfig: {
            type: Object,
            required: true
        },
        isDisable: {type: Boolean, default: true},
        markerPosition: {
            type: String,
            default: ""
        },
    },
    components: {
        InputText,
        DateTimePicker,
        MainButton,
        InputDropdown,
        InputContactNumber,
        InputNationalId,
        InputTermsAndCond,
        InputRadio,
        InputUpload
    },
    emits: ["onSubmit"],
    setup: function (props, ctx) {
        /**@type {import("@/types/Modal.d").ModalStore} */
        const modalStore = inject("ModalStore");
        const modalController = modalStore.methods.getModalController()
        const { lbl } = inject("LocaleStore")
        const errInfo = ref(FormHelper.genErrorInfo(props.formType == "now" ? 8 : 9))
        const model = ref(new ClaimNoRegisterModel())
        const isSubmitted = ref(false)
        const ddlTitleName = ref([])
        const ddlProvince = ref([])

        const currentDt = DateTime.now()
        const minDate = currentDt.toJSDate()

        const isCanSubmit = computed(() => {
            // console.log(locationValid.value, isSubmitted.value)
            if (!FormHelper.validate(errInfo.value)) {
                return false
            }

            return true
        })

        const setDefaultAppointDate = function () {
            let tomorrow = DateTime.now().startOf("day").plus({ days: 1 })

            model.value.appointDate = tomorrow.toJSDate()
            model.value.appointTime = { hours: 9, minutes: 0 }
        }

        const onUpdateProvince = function(provinceCode){
            // console.log(provinceCode)
            let p = ddlProvince.value.find(x=> x.value == provinceCode)
            model.value.setProvinceName(p.extra) // ProvinceName
        }

        const submitForm = function () {
            isSubmitted.value = true

            if (!FormHelper.validate(errInfo.value)) {
                return
            }

            // chekc form config
            if(props.formConfig?.upload_id_card == true && model.value.imgIdCard == null){
                return
            }

            if(props.formConfig?.upload_car_plate == true && model.value.imgCarPlate == null){
                return
            }

            ctx.emit("onSubmit", model.value)
        }

        const loadDropdownItems = function () {
            ClaimNonRegisterService.apiGetTitleName().then((items) => {
                ddlTitleName.value = items
            })

            ClaimNonRegisterService.apiGetLicensePlateProvinces().then((items) => {
                ddlProvince.value = items
            })
        }

        const onRedPlateChange = function(isRedPlate){
            if(isRedPlate == true){
                // show popup
                modalController.redLicensePlateModal.clearModal().show()
            }
        }

        const setNameTitle = function() {
            if (props.formType == 'now') {
                model.value.appointmentLocation = props.markerPosition
                model.value.nameTitle = 'คุณ'
            }
        }

        // init
        model.value.setFormType(props.formType)
        setDefaultAppointDate()
        loadDropdownItems()
        setNameTitle()

        return {
            lbl,
            model,
            errInfo,
            isSubmitted,
            isCanSubmit,
            minDate,
            ddlTitleName,
            ddlProvince,
            submitForm,
            onUpdateProvince,
            onRedPlateChange
        }
    }
}
</script>